import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from 'convex/react'
import { api } from '@backend/_generated/api'
import type { Id } from '@backend/_generated/dataModel'
import { InvitedDirectReportsTable } from '@/features/direct-reports'
import type { InvitedDirectReport } from '@/features/direct-reports/types'
import { useMyConvexUserId, useMyConvexOrganizationId } from '@/features/auth'

export const Route = createFileRoute('/(dashboard)/direct-reports/invited/')({
  component: RouteComponent,
})

function RouteComponent() {
  const managerId = useMyConvexUserId()
  const organizationId = useMyConvexOrganizationId()

  const invites = useQuery(
    api.invites.listByManager,
    managerId && organizationId
      ? {
          managerId: managerId as Id<'users'>,
          organizationId: organizationId as Id<'organizations'>,
        }
      : 'skip',
  )

  const isLoading = invites === undefined

  const pendingInvites = (invites ?? []).filter(
    (inv) => inv.status.toLowerCase() === 'pending',
  ) as unknown as Array<InvitedDirectReport>

  return (
    <InvitedDirectReportsTable
      invites={pendingInvites}
      isLoading={isLoading}
      currentPage={1}
      totalPages={1}
      totalInvites={pendingInvites.length}
      onPageChange={() => {}}
    />
  )
}
